import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { motion } from "framer-motion";
import { BsAndroid, BsApple, BsBrowserChrome } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.3 }}>
      <Card className="project-card-view">
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>
          <div className="project-card-buttons">
            {props.androidLink && (
              <Button variant="primary" href={props.androidLink} target="_blank">
                <BsAndroid /> Android
              </Button>
            )}
            {props.iosLink && (
              <Button variant="primary" href={props.iosLink} target="_blank">
                <BsApple /> iOS
              </Button>
            )}
            {props.demoLink && (
              <Button variant="primary" href={props.demoLink} target="_blank">
                <BsBrowserChrome /> Website
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>
    </motion.div>
  );
}

export default ProjectCards;
